<div class="page-header-block w-100">

  <!-- this is just a spacer for the layout -->
  <div class="festo-content">
    <div class="machine-bar-spacer"></div>
  </div>

  <ecn-machine-bar />
</div>

<router-outlet />
